import EntriesPicker from './EntriesPicker';
import ContestSelect from './ContestSelect';
import { Form, Header } from './';
import { formPropTypes } from './common';

import React from 'react';
import {
  filter,
  find,
  get,
  last,
  map,
  max,
  orderBy,
  range,
  sortBy,
} from 'lodash';

const GroupForm = ({ formProps, values, meta, onInputChange }) => {
  const contestOptions = meta.contests.filter(
    contest =>
      contest.entries.length &&
      contest.entries.some(
        ({ id }) => get(find(meta.entries, { id }), 'group') === undefined,
      ),
  );

  const currentContest = find(meta.contests, { primaryKey: values.contest });
  const currentLetter = values.letter || 'A';
  const usedLetters = sortBy(
    map(filter(meta.groups, ['contest.primaryKey', values.contest]), 'letter'),
  );
  const lastLetterCode = max([
    'A'.charCodeAt(),
    last(['A', ...usedLetters]).charCodeAt() +
      (last(usedLetters) !== currentLetter) * 1,
  ]);
  const letterOptions = range('A'.charCodeAt(), lastLetterCode + 1)
    .map(charCode => String.fromCharCode(charCode))
    .map(letter => ({
      key: letter,
      disabled: letter !== currentLetter && !!find(meta.groups, { letter }),
      value: letter,
      text: letter,
    }));

  const entriesOptions = orderBy(
    get(currentContest, 'entries', []),
    ['referenceTotal', 'lotNumber'],
    ['desc', 'asc'],
  )
    .map(({ id }) => find(meta.entries, { id }))
    .map(entry => ({
      ...entry,
      disabled: !!entry.group && entry.group.letter !== values.letter,
    }));

  return (
    <Form {...formProps}>
      <Form.Group widths="equal">
        <Form.Field
          control={ContestSelect}
          disabled={!!values.entries && !!values.entries.length}
          name="contest"
          options={contestOptions}
          value={values.contest || []}
          onChange={onInputChange}
          meta={meta}
          label="Contest"
          placeholder="Contest"
          required
          fluid
        />
        <Form.Select
          name="letter"
          options={letterOptions}
          value={values.letter || ''}
          onChange={onInputChange}
          label="Letter"
          placeholder="Letter"
          required
          fluid
        />
      </Form.Group>
      <Header>Entries</Header>
      <EntriesPicker
        name="entries"
        value={values.entries || []}
        options={entriesOptions}
        onChange={onInputChange}
        meta={meta}
      />
    </Form>
  );
};

GroupForm.propTypes = formPropTypes;

export default GroupForm;



// WEBPACK FOOTER //
// ./src/components/GroupForm.js